export const maxMobile = 820;
export const minPortraitTablet = 600;
/* ??? */
export const ipadPortrait = 768;
/* 768px */
export const ipadLandscape = 1024;
export const maxTablet = 1024;
/* 1024px */
export const smallLaptop = 1350;
/* var(--breakpoint-m) */

export const ipadPortraitAndDown = `@media (max-width: ${ipadPortrait - 1}px)`;
/* down: @media (max-width: 767px) {} */
export const portraitTabletAndDown = `@media (max-width: ${ipadLandscape - 1}px)`;
/* down: @media (max-width: 1023px) {} */
export const portraitTabletAndUp = `@media (min-width: ${ipadPortrait}px)`;
/* up: @media (min-width: 768px) {} */
export const landscapeTabletAndDown = `@media (max-width: ${ipadLandscape}px)`;
/* down: @media (max-width: 1023px) {} */
export const landscapeTabletAndUp = `@media (min-width: ${ipadLandscape}px)`;
/* up: @media (min-width: 1024px) {} */
export const tabletTrue = `@media (min-width: ${ipadPortrait}px) and (max-width: ${ipadLandscape}px)`;
/* up: @media (min-width: 768px) and (max-width: 1024px) {} */
export const mobileTrue = `@media (max-width: ${ipadPortrait - 1}px)`;
/* down: @media (max-width: 767px) {} */
export const desktopTrue = `@media (min-width: ${ipadLandscape + 1}px)`;
/* up: @media (min-width: 1024px) {} */
export const smallLaptopAndDown = `@media (max-width: ${smallLaptop - 1}px)`;
/* down: @media (max-width: 1349px) {} */
